<template>
    <div class="container">
        <div class="row" style="align-content: start;" v-if="loaded">
            <div class="col-xxl-4 col-12 row p-0 align-top" style="align-content: start;">
                <div class="col-12 p-0 pt-3">
                    <div class="page-heading p-0">
                        <div class="p-0 avatar-image">
                            <img :src="'/assets/dipocaco/avatars/'+profileData.account.avatar.filename" alt="" class="">
                        </div>
                        <div class="profile-info row p-0 w-100">
                            <div class="col-12 mb-2">
                                <h4>{{ profileData.username }}</h4>
                                <small class="muted registered p-0">Registered {{ getCreatedAt() }}</small>
                                <span class="mt-2 d-block">
                                    <strong class="mr-2">{{ profileData.followers.length }}</strong> Followers |
                                    <strong class="mr-2">{{ profileData.followed_users.length }}</strong> Following
                                </span>
                            </div>
                            <div class="mt-2 col-12" v-if="!ownProfile">
                                <a href="javascript:" class="btn btn-danger w-100" v-if="followings.includes(profileData.id)" v-on:click="toggleFollow()">Unfollow</a>
                                <a href="javascript:" class="btn btn-success w-100" v-else v-on:click="toggleFollow()">Follow</a>
<!--                                <div class="float-end mt-2">-->
<!--                                    <a href="javascript:" class="text-danger report-link">Report User <i class="fa-solid fa-warning"></i></a>-->
<!--                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 medals p-0 row align-top">
                    <div class="col-4">
                        <img :src="getMedal('earned')" alt=""><br/>
                        <small class="muted">
                            {{ this.profileData.statistics.earned.toLocaleString() }}
                            <small class="muted">Credits earned</small>
                        </small>
                    </div>
                    <div class="col-4">
                        <img :src="getMedal('boosters_opened')" alt=""><br/>
                        <small class="muted">
                            {{ this.profileData.statistics.boosters_opened.toLocaleString() }}
                            <small class="muted">Boosters opened</small>
                        </small>
                    </div>
                    <div class="col-4">
                        <img :src="getMedal('sold_cards')" alt=""><br/>
                        <small class="muted">
                            {{ this.profileData.statistics.sold_cards.toLocaleString() }}
                            <small class="muted">Cards sold</small>
                        </small>
                    </div>
                </div>

                <div class="col-12 mt-4" v-if="profileData.user_collections.filter(c => c.is_public).length > 0">
                    <div class="row p-0">
                        <div class="col-12 p-0">
                            <h4>{{ profileData.username }}'s Collections</h4>
                            <div class="row p-0">
                                <router-link v-for="collection in profileData.user_collections.filter(c => c.is_public)"
                                             :key="collection.id"
                                             :to="{ name: 'collection', params: { collection_id: collection.id }}"
                                             class="col-6 col-md-6 col-lg-6 col-xl-6 mb-1 collection-router-link">
                                    <div class="collection-binder">
                                        <div class="collection-cover user profile" :style="'background-image: url('+collection.cover_url+')'">

                                        </div>
                                    </div>
                                    <div class="text-center w-100">
                                        <small class="muted">
                                            {{ collection.name }}
                                        </small>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-4">
                    <div class="row p-0">
                        <div class="col-12 p-0">
                            <h4>User level</h4>
                            <span class="level-display">
                                <img src="/assets/dipocaco/level_x64.png" alt="" class="currency-icon" title="Level"> {{ userLevel }}
                            </span>
                            <div class="form-group" v-if="ownProfile">
                                <label for="toNextLevel" class="label text-dark">{{ $store.getters.toNextLevel }} XP / {{ $store.getters.levelXp }} XP to Level {{ $store.getters.level + 1 }}</label>
                                <progress :value="$store.getters.toNextLevel" max="20000" class="w-100"></progress>
                            </div>
                        </div>
                        <div class="col-6 p-0 text-center follower-display">
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-1">
                    <div class="">
                        <a href="javascript:" data-bs-toggle="offcanvas" data-bs-target="#achievements-canvas" class="btn btn-success w-100">Achievements</a>
                    </div>
                </div>

                <div class="col-12 mt-1">
                    <div class="">
                        <a href="javascript:" class="btn btn-warning w-100" v-on:click="openWishlistModal()">Wishlist</a>
                    </div>
                </div>

                <div class="canvas">
                    <div v-on:blur="closeModal()" class="offcanvas offcanvas-end" id="achievements-canvas" tabindex="-1" role="dialog" aria-labelledby="card-detail-view-canvas-label" aria-hidden="true">
                        <div class="offcanvas-header">
                            <h3 class="text-center text-dark">
                                Achievements
                                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </h3>
                        </div>
                        <div class="offcanvas-body">
                            <div v-if="$store.state.user.achievements.length > 0">
                                <h4>Unlocked achievements</h4>
                                <div class="card mb-2 bg-dark text-light" v-for="achievement in $store.state.user.achievements">
                                    <div class="card-body pt-1 achievement-card">
                                        <div class="pt-2 float-end">
                                            <i class="pl-2 fa-solid fa-trophy fa-2x" style="color: goldenrod"></i>
                                        </div>
                                        <h5>{{ achievement.achievement.title }}</h5>
                                        <span>{{ achievement.achievement.message }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4">
                                <h4>Locked achievements</h4>
                                <div class="card mb-2 bg-dark text-light" v-for="achievement in achievments">
                                    <div class="card-body pt-1 achievement-card">
                                        <div class="pt-2 float-end">
                                            <i class="pl-2 fa-solid fa-trophy fa-2x" style="color: goldenrod"></i>
                                        </div>
                                        <h5>{{ achievement.title }}</h5>
                                        <span>{{ achievement.message }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xxl-8 col-12 row p-0 pt-3">
                <div class="col-12 d-none d-xl-block postings-fixed-height">
                    <h4>Postings</h4>
                    <div v-for="posting in profileData.postings">
                        <posting :posting="posting" v-on:postingDeleted="loadProfile"></posting>
                    </div>
                </div>
                <div class="col-12 d-xl-none">
                    <h4>Postings</h4>
                    <div v-for="posting in profileData.postings">
                        <posting :posting="posting" v-on:postingDeleted="loadProfile"></posting>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal modal-xl fade" id="profile-wishlist-modal" tabindex="-1" aria-labelledby="#profile-wishlist-modal-label" aria-hidden="true" v-if="loaded">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header justify-content-between">
                        <h1 class="modal-title fs-5 w-100" id="profile-wishlist-modal-label">
                            {{ profileData.username }}'s Wishlist
                        </h1>
                        <button type="button" class="btn-close text-reset" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body row">
                        <div class="col-12" v-if="myCardsOnTheirWishlist.length > 0">
                            <div class="alert alert-info">It seems you have some cards from their wishlist in your inventory! Select one to create a trade offer</div>
                        </div>

                        <a class="col-4 pb-2" v-for="card in myCardsOnTheirWishlist" :key="card.id" v-on:click="redirectToTradingOffer(card)">
                            <img loading="lazy" :src="CardService.getSmallCardImageUrl(card)" :alt="card.name+' thumbnail'" class="w-100">
                        </a>

                        <div class="col-12" v-if="myCardsOnTheirWishlist.length > 0">
                            <hr/>
                        </div>

                        <a class="col-4 pb-2" v-for="card in profileData.wishlist_cards" :key="card.id" v-on:click="showCardCanvas(card)">
                            <img loading="lazy" :src="CardService.getSmallCardImageUrl(card)" :alt="card.name+' thumbnail'" class="w-100">
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <card-detail-view-auto-load-canvas></card-detail-view-auto-load-canvas>
        <card-detail-view-canvas :gallery="true" :card="cardToShow"/>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import izitoast from "izitoast";
import Posting from "../parts/Posting.vue";
import medalRequirements from "../../data/medalRequirements";
import CardDetailViewAutoLoadCanvas from "../parts/CardDetailViewAutoLoadCanvas.vue";
import CardService from "../../CardService";
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";

export default {
    name: "UserProfile",
    components: {CardDetailViewCanvas, CardDetailViewAutoLoadCanvas, Posting},
    data() {
        return {
            loaded: false,
            ownProfile: false,
            profileData: {},
            followings: [],
            achievments: [],
            cardToShow: null
        }
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.$store.commit('updateUserCards');
        this.loadOwnFollowings();
        this.loadProfile();
    },
    computed: {
        CardService() {
            return CardService
        },
        userLevel() {
            return (this.profileData.account.xp - (this.profileData.account.xp % 20_000)) / 20_000 + 1;
        },
        myCardsOnTheirWishlist() {
            return this.profileData.wishlist_cards.filter(c => this.$store.getters.cardIdsInCollection.includes(c.id));
        }
    },
    methods: {
        showCardCanvas(card) {
            this.cardToShow = card;
            setTimeout(() => {
                $("#card-detail-view-canvas").offcanvas('toggle');
            }, 100)
        },
        loadOwnFollowings() {
            axios.get('/api/social/followings').then((response) => {
                this.followings = response.data.map(f => f.followed_user_id);
                this.$forceUpdate();
            })
        },
        loadProfile() {
            axios.get('/api/users/' + this.$route.params.username).then((response) => {
                this.profileData = response.data;
                this.profileData.postings = this.profileData.postings.reverse();
                this.profileData.wishlist_cards = this.profileData.wishlist_cards.map(c => JSON.parse(c.card.json))
                this.ownProfile = this.profileData.username === this.$store.state.user.username;

                if (this.ownProfile) {
                    this.$store.commit('loadAchievements');
                    this.fetchAchievements();
                }

                this.loaded = true;
            })
        },
        getMedal(field) {
            let baseMedalPath = '/assets/dipocaco/medals/';
            let reachedMedal = null;

            switch (field) {
                case 'earned':
                    baseMedalPath += 'earned_';
                    break;
                case 'boosters_opened':
                    baseMedalPath += 'boosters_';
                    break;
                case 'sold_cards':
                    baseMedalPath += 'cards_';
                    break;
                default:
                    baseMedalPath = null;
            }

            if (!baseMedalPath) {
                return false;
            }

            Object.keys(medalRequirements[field]).forEach((key) => {
                if (reachedMedal) {
                    return false;
                } else if (this.profileData.statistics[field] > medalRequirements[field][key]) {
                    reachedMedal = baseMedalPath + key + '.png';
                }
            });

            return reachedMedal ?? (baseMedalPath + 'base.png');
        },
        getCreatedAt() {
            return moment(this.profileData.created_at).fromNow()
        },
        toggleFollow() {
            axios.post('/api/social/follow', {
                idToFollow: this.profileData.id
            }).then(response => {
                this.loadOwnFollowings();
                this.loadProfile();

                if (response.data.nowFollowing) {
                    izitoast.success({
                        title: "You're now following "+this.profileData.username
                    })
                } else {
                    izitoast.success({
                        title: "You're not following "+this.profileData.username+" anymore"
                    })
                }
            })
        },
        fetchAchievements() {
            fetch('/api/achievements').then(r => r.json()).then((response) => {
                this.achievments = response;
            })
        },
        openWishlistModal() {
            $('#profile-wishlist-modal').modal('toggle');
        },
        redirectToTradingOffer(card) {
            $('#profile-wishlist-modal').modal('toggle');
            this.$router.push({ name: 'trading', params: { tab: 'new', user: this.profileData.username, card: card.id }});
        }
    }
}
</script>

<style lang="scss" scoped>
.avatar-list-icon {
    max-height: 9em;
}

.level-display {
    font-size: 2em !important;
    text-decoration: none;
    display: inline-block;

    img {
        max-height: 1em;
        margin-top: -0.2em;
        z-index: 20;
    }
}

//.avatar-image {
//    vertical-align: top;
//    display: inline-block;
//    max-width: 40%;
//    border-radius: 1000px;
//    border: 5px solid black;
//    background-color: grey;
//
//    img {
//        max-width: 100%;
//    }
//}

.profile-info {
    vertical-align: top;
    display: inline-block;
    margin-left: 1em;

    h4 {
        margin-top: 1em !important;
        margin-bottom: 0;
    }
}

.medals {
    margin-top: 2em;
    text-align: center;

    img {
        max-width: 100%;
    }

    .muted {
        white-space: nowrap;

        .muted {
            color: dimgrey;
            display: block;
            margin-top: 0;
            font-size: 0.95em;
            white-space: nowrap;
        }
    }
}

.achievement-card {
    min-height: 3.5em;
}

.page-heading {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: stretch;
    align-items: flex-start;
    align-content: flex-start;
}

.report-link {
    text-decoration: none !important;
}

.registered {
    display: block;
}

.postings-fixed-height {
    height: 90vh;
    overflow-x: auto;
}

.follower-display {
    font-size: 2em !important;
    vertical-align: middle;
    flex-direction: column;
    justify-content: flex-end;

    h5 {
        font-size: 0.3em;
    }
}

.profile-wrapper {
    align-content: flex-start !important;
}
</style>
